import { DataService } from '../services/data_service';
import DialogWrapper2 from '../core/dialog/dialog_wrapper_v2';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as Moment from 'moment';
import parse from 'html-react-parser';
import * as React from 'react';
import { WSpinner } from '../core/elements/spinner/WSpinner';

export interface AktuelleNachrichtenProps {
    entity: string;
    onNarrowScreen?: boolean;
}

export interface AktuelleNachrichtenState {
    dataRows: any[];
    infoRow: any;
    isLoading: boolean;
}

export class AktuelleNachrichten extends React.Component<AktuelleNachrichtenProps, AktuelleNachrichtenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataRows: null,
            infoRow: null,
            isLoading: false
        };
    }

    @lazyInject(DataService) private dataService: DataService;

    private cache: any = {};

    componentDidMount(): void {
        this.loadDataRows();
    }

    async getData(entity: string, filter?: any, settings?: any): Promise<any[]> {
        return (await this.dataService.async_loadData(entity, filter, settings, IDs.MOD_ETOOL_ADMIN) || {})[entity] || [];
    }

    loadDataRows(): void {
        this.dataService.loadData(
            this.props.entity,
            // [{ field: 'deaktiviert', op: 'IS NULL', val: 'OR deaktiviert = 0' }],
            [
                { field: 'deaktiviert', op: 'IS NULL' },
                { field: 'deaktiviert', op: '=', val: 0, log_op: 'OR' },
            ],
            { fieldList: 'tid, datum, name, inhalt_kurz' },
            (res: any) => {
                // console.log(res, JSON.stringify(res).length);
                let dataRows: any[] = (res || {})[this.props.entity] || [];
                if (this.props.entity === IDs.ENT_AKTUELLE_TERMINE) {
                    const now = new Date().getTime() / 1000;
                    const limit = now - (now % 86400);
                    // console.log('Limit', limit, dataRows);
                    dataRows = dataRows.filter((r: any) => (r.datum - (r.datum % 86400)) >= limit);
                    dataRows.sort((a: any, b: any) => a.datum - b.datum);
                } else {
                    dataRows.sort((a: any, b: any) => b.datum - a.datum);
                }
                // this.processDataRows(dataRows);
                this.setState({ dataRows });
            }, IDs.MOD_ETOOL_ADMIN);
    }

    async onClickItem(data: any): Promise<void> {
        const tid: number = (data || {}).tid || null;

        if (!this.cache[tid]) {
            const item: any = ((await this.getData(this.props.entity, { tid })) || [])[0] || {};
            this.processDataRows([item]);
            this.cache[tid] = item;
            this.setState({ infoRow: item, isLoading: false });
        } else {
            this.setState({ infoRow: this.cache[tid], isLoading: false });
        }
    }

    processDataRows(rows: any[]): void {
        rows.forEach((r: any) => {
            r.inhalt = typeof r.inhalt === 'string' ? r.inhalt : '';
            const p = parse(r.inhalt);
            r.inhalt_parse = p;
            r.inhalt_table = <div style={{ padding: 3 }}>{p}</div>;
        });
    }

    render(): JSX.Element {
        const { dataRows, infoRow } = this.state;
        const type: string = this.props.entity === IDs.ENT_AKTUELLE_TERMINE ? 'date' : 'news';

        return <>
            {(dataRows || []).map((r: any, idx: number) =>
                <div
                    className='news-item'
                    key={`row-${idx}`}
                    onClick={() => this.setState({ isLoading: true }, async () => this.onClickItem(r))}
                // onClick={() => this.setState({ infoRow: r })}
                >
                    <span className='date'><i className={`${type}-icon`}></i> {Moment.unix(r.datum || 0).format('DD.MM.YYYY')}</span>
                    {r.name} →
                </div>
            )}
            {infoRow && this.renderNewsDlg()}
            {this.state.isLoading && <WSpinner />}
        </>;
    }

    render_old(): JSX.Element {
        const title = this.props.entity === IDs.ENT_AKTUELLE_TERMINE ? 'TERMINE' : 'NEWS';
        const { dataRows, infoRow } = this.state;

        return (
            <div
                style={{
                    display: 'flex', flexDirection: 'column', border: 0, /*height: 'fit-content',*/ fontSize: 14, width: 376,
                    maxHeight: 285, ...(this.props.onNarrowScreen ? { margin: '30px 10px 0 10px' } : { marginTop: 338 })
                }}
            >
                <div
                    style={{
                        padding: 5, fontWeight: 'bold', backgroundColor: 'rgb(188, 202, 227)', borderTopLeftRadius: 10,
                        borderTopRightRadius: 10, textAlign: 'center'
                    }}
                >
                    {title}
                </div>
                <div style={{ height: 500, overflow: 'auto', border: '1px solid lightgray', justifyContent: 'flex-start' }}>
                    {(dataRows || []).map((r: any, idx: number) =>
                        <div
                            key={`row-${idx}`}
                            style={{ padding: 5, paddingTop: 10, borderBottom: '1px solid lightgray', fontSize: 12, cursor: 'pointer' }}
                            onClick={() => this.setState({ isLoading: true }, async () => this.onClickItem(r))}
                        // onClick={() => this.setState({ infoRow: r })}
                        >
                            <div style={{ display: 'flex', flexDirection: 'row', fontWeight: 'bold' }}>
                                <div style={{ flex: 1 }}>{Moment.unix(r.datum || 0).format('DD.MM.YYYY')}</div>
                                <div style={{ flex: 4 }}>{r.name}</div>
                            </div>
                            <div style={{ marginTop: 5, maxHeight: 100, overflow: 'auto', paddingLeft: 78 }}>{r.inhalt_kurz}</div>
                        </div>
                    )}
                </div>
                {infoRow && this.renderNewsDlg()}
                {this.state.isLoading && <WSpinner />}
            </div>
        );
    }

    renderNewsDlg(): JSX.Element {
        const { infoRow } = this.state;
        const spacer: string = Array(5).join('\u00a0');
        const title: string = `${Moment.unix(infoRow.datum || 0).format('DD.MM.YYYY') || ''}${spacer}"${infoRow.name || ''}"`;

        return (
            <DialogWrapper2
                title={title}
                styleClassExternal='dialog-content'
                width={-1}
                verticalAlignCenter
                onAfterClose={() => this.setState({ infoRow: null })}
            >
                <div style={{ fontSize: 14, width: 800, margin: '0 0 20px 20px', paddingTop: 10, paddingRight: 20, overflowY: 'auto' }}>
                    <div ref={(ref: any) => ref ? setTimeout(() => ref.scrollTop = 0) : null}>
                        {infoRow.inhalt_parse}
                    </div>
                </div>
            </DialogWrapper2>
        );
    }
}
